import React from 'react';
import { IMAGE_404 } from '@/bizComponents/images/404';
import { IMAGE_NOT_FOUND } from '@/bizComponents/images/notFound';
import { Button } from '@zbanx-coding/components-basic';
import { ArrowRightOutlined } from '@zbanx/icons';
import { useTranslation } from 'react-i18next';
import { Helmet, useHistory } from 'umi';
import Footer from '@/bizComponents/pageContainer/components/footer';
import Header from '@/bizComponents/pageContainer/components/header';
import css from './index.less';
import { transformToWebp } from '@/utils/image';

export interface Props {}

export const Page404: React.FC<Props> = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={css.page404}>
      <Helmet>
        <title data-http-error-status-code="404">{t('404.title')}</title>
      </Helmet>
      <Header className={css.header} />
      <div className={css.main}>
        <div className={css.notFound}>
          <div className={css.content}>
            <div className={css.left}>
              <img src={transformToWebp(IMAGE_NOT_FOUND)} alt="not found" />
            </div>
            <div className={css.right}>
              <div className={css.rightContent}>
                <img src={transformToWebp(IMAGE_404)} alt="404" />
                <p>{t('404.gone')}</p>
                <Button
                  size="large"
                  href="/"
                  title={t('404.back')}
                  onClick={(e) => {
                    e.preventDefault();
                    history.push('/');
                  }}
                >
                  <span>{t('404.back')}</span>
                  <ArrowRightOutlined />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer className={css.footer} />
    </div>
  );
};

export default Page404;
